import { render, staticRenderFns } from "./dashboardDanweiWanchengdu.vue?vue&type=template&id=6ed714e2&scoped=true"
import script from "./dashboardDanweiWanchengdu.vue?vue&type=script&lang=js"
export * from "./dashboardDanweiWanchengdu.vue?vue&type=script&lang=js"
import style0 from "./dashboardDanweiWanchengdu.vue?vue&type=style&index=0&id=6ed714e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed714e2",
  null
  
)

export default component.exports